import { render } from "./TubeImagesAdminView.vue?vue&type=template&id=bf2ef6b0&scoped=true"
import script from "./TubeImagesAdminView.vue?vue&type=script&lang=js"
export * from "./TubeImagesAdminView.vue?vue&type=script&lang=js"

import "./TubeImagesAdminView.vue?vue&type=style&index=0&id=bf2ef6b0&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf2ef6b0"]])

export default __exports__